export default __webpack_public_path__ + "static/media/1212-00.cabaa389.jpg";